import retryFetch from "./retryFetch";
import { config } from '../../config/config'

export const getSignedUrl = (token, env, filename) => {
    return retryFetch(`${config.endpoints.dynatablesBackend}/file?fileName=${filename}`, {
        retryOn: [202],
        retries: 100,
        retryDelay: 30000,
        headers: {
            'Content-Type': 'application/json',
            token,
            tokensource: 'purecloud',
            env
        }
    }).then(response => response.json())
}

export const initiateDownload = (token, env, filename) => {
    return fetch(`${config.endpoints.dynatablesBackend}/requestFile?fileName=${filename}`, {
        headers: {
            token,
            tokensource: 'purecloud',
            env
        }
    }).then(response => {
        if (response.status !== 202) {
            const err = 'could not start downloading the file'
            throw err
        }
        return response.json()
    })
}

export const queryRecord = (token, env, filename, queryKey, queryValue) => {
    return fetch(`${config.endpoints.dynatablesBackend}/record?fileName=${filename}&QueryKey=${queryKey}&QueryValue=${queryValue}`, {
        headers: {
            token,
            tokensource: 'purecloud',
            env
        }
    }).then(response => response.json())
}

export const updateRecord = (token, env, filename, queryKey, queryValue, body) => {
    return fetch(`${config.endpoints.dynatablesBackend}/record?fileName=${filename}&QueryKey=${queryKey}&QueryValue=${queryValue}`, {
        method: 'PATCH',
        headers: {
            token,
            tokensource: 'purecloud',
            env
        },
        body: JSON.stringify(body)
    }).then(response => response.json())
}

export const appendRecord = (token, env, filename, body) => {
    return fetch(`${config.endpoints.dynatablesBackend}/record?fileName=${filename}`, {
        method: 'POST',
        headers: {
            token,
            tokensource: 'purecloud',
            env
        },
        body: JSON.stringify(body)
    }).then(response => response.json())
}